import Vue from 'vue';

export const tesEmployeeDetailsService = {
  async retrieveTesEmployee(referenceNumber) {
    return Vue.axios.get(`/tes-employees/${referenceNumber}`).then(response => response.data);
  },

  async validateCommissionNumber(commission_number) {
    return Vue.axios.get(`/tes-employees/commissions/${commission_number}`);
  },

  async saveTesEmployee(tesEmployeeData, action) {
    let actionUrl = tesEmployeeData.reference_number
      ? `/tes-employees/${tesEmployeeData.reference_number}?action=${action}`
      : `/tes-employees/create?action=${action}`;

    return Vue.axios
      .post(actionUrl, {
        ...tesEmployeeData
      })
      .then(response => response.data);
  }
};
